jQuery(document).ready(function($) {
  if (!$('.leadership').length) {
    return;
  }

  if (jQuery(window).width() < 768) {
    leadershipMobile($);
  }
});

function leadershipMobile($) {
  $('.leadership .container .list').each(function () {
    const listElement = this;

    $(listElement)
      .find('.mobile-text.mobile-short-text .read-more')
      .on('click', function () {
        $(listElement)
          .find('.mobile-text.mobile-short-text')
          .addClass('hide');
        $(listElement)
          .find('.mobile-text.mobile-detail-text')
          .removeClass('hide');
      });

    $(listElement)
      .find('.mobile-text.mobile-detail-text .read-more')
      .on('click', function () {
        $(listElement)
          .find('.mobile-text.mobile-detail-text')
          .addClass('hide');
        $(listElement)
          .find('.mobile-text.mobile-short-text')
          .removeClass('hide');
      });
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/leadership.js